import { render } from "./BrandMeinMed.vue?vue&type=template&id=59b43c47"
import script from "./BrandMeinMed.vue?vue&type=script&lang=ts"
export * from "./BrandMeinMed.vue?vue&type=script&lang=ts"

import "./BrandMeinMed.vue?vue&type=style&index=0&id=59b43c47&lang=scss"
script.render = render

export default script